<ng-container *transloco="let t">
  <ul class="d-flex flex-column unlist-group {{ options?.class }}">
    <li *ngFor="let menu of sharedMenus | orderBy: 'order' | filterByRole:options" >
      <app-shared-menu-item [item]="menu"></app-shared-menu-item>
    </li>
  </ul>
</ng-container>
